import { SpreadsheetNoteData, SpreadsheetNotePersistedCell } from 'components/SpreadsheetNotes/types';
import { ReverseParserParams } from 'models/interfaces/spreadsheet-types/core-types';

const SpreadsheetNoteReverseParser = (params: ReverseParserParams<SpreadsheetNoteData, object, object, object> ) => {
  const { cells, initialObj } = params;
  if (!initialObj) {
    throw new Error('Initial object is required for reverse parsing spreadsheet notes');
  }
  initialObj.content.cells = Object.values(cells).filter(cell => {
    const value = cell.expr ?? cell.value;
    return (value !== undefined && value !== null && value !== '')
  }).reduce((acc, cell) => {
    const { key, value, expr } = cell;
    acc[key] = {
      key,
      value: value?.toString() || '',
      expr: expr?.toString() || ''
    }
    return acc;
  }, {} as {[key: string]: SpreadsheetNotePersistedCell});
}

export const PreviewNoteReverseParser = (params: ReverseParserParams<SpreadsheetNoteData, object, object, object> ) => {
  // Preview notes are readonly however in the instance where they are not, reverse parsing will take place here 
  const { cells, initialObj } = params;

  if (!initialObj?.content?.cells) {
    throw new Error('Initial object is required for reverse parsing spreadsheet notes');
  }

  Object.entries(initialObj.content.cells).forEach(([key, initialCell]) => {
    // eslint-disable-next-line no-param-reassign
    initialCell.value = (cells[key]?.value ?? '').toString()
  })
}
export default SpreadsheetNoteReverseParser;